<template>
  <section class="choose-theme-sec">

        <!-- sidebar start -->
        <chat-sidebar class="chatDetailsSideabr"></chat-sidebar>
        <!-- sidebar end -->

        <!-- main-content start -->
        <div class="main-content main-chat-content">

            <!-- chat top bar start -->
            <direct-chat-topbar v-if="chatTopbar=='' || chatTopbar=='direct'"></direct-chat-topbar>
            <group-chat-topbar v-else></group-chat-topbar>
            <!-- chat top bar end -->


            <!-- direct-chat-details start -->
            <direct-chat-details></direct-chat-details>
            <!-- direct-chat-details end -->

        </div>
        <!-- main-content end -->



  </section>
</template>

<script>
    import { EventBus } from '../main';
    export default {

        data() {
            return {
                chatTopbar:''
            }
        },

        methods: {

          setActiveInSession(){
            if(localStorage.getItem('setActive')) {
              this.chatTopbar=localStorage.getItem('setActive');
            } else {
              this.chatTopbar='direct';
            }
          },

          isCurrentRoute() {

              let url = this.$route.path;
              url = url.slice(0, url.lastIndexOf('/'));

              if(url==='/chat-details'){
                EventBus.$emit('isCurrentRoute',false);
              } 

              return;

          }

        },

        mounted() {

         this.isCurrentRoute();
          // Is collection modal open or not
          EventBus.$on('setActive', data => {
            this.chatTopbar = data;
          });
         this.setActiveInSession();
         this.isCurrentRoute();
        }

    }

</script>

<style>
    .main-content.main-chat-content {
        padding-right: 0;
        margin-right: 3px;
        align-items: flex-start;
            padding-top: 10px;
    }

    .chatDetailsSideabr{
        display: block;
    }


</style>


